import { ErrorResponseCode } from 'api/models/error-response-code';
import { Meals } from 'components/Cart/cartContext';
import {
  TXT_ERROR,
  TXT_ERROR_ALREADY_EXISTS,
  TXT_ERROR_BAD_REQUEST,
  TXT_ERROR_CATEGORY_NOT_FOUND,
  TXT_ERROR_CLOSED_FOR_WRITE,
  TXT_ERROR_COMPANY_NOT_FOUND,
  TXT_ERROR_DEBTOR_USER,
  TXT_ERROR_FORBIDDEN,
  TXT_ERROR_IMAGE_NOT_FOUND,
  TXT_ERROR_INTEGRATION_ERROR,
  TXT_ERROR_INVALID_REQUEST_PARAMS,
  TXT_ERROR_MENU_ITEM_NOT_FOUND,
  TXT_ERROR_MENU_NOT_FOUND,
  TXT_ERROR_NAME_NOT_FOUND,
  TXT_ERROR_NOT_FOUND,
  TXT_ERROR_PRODUCT_NOT_FOUND,
  TXT_ERROR_READ_IMAGE_BYTES_ERROR,
  TXT_ERROR_SERVER_ERROR,
  TXT_ERROR_UNAUTHORIZED,
} from 'translations';

interface GetErrorCodeMessageProps {
  code: ErrorResponseCode;
}

export const getErrorCodeMessage = ({ code }: GetErrorCodeMessageProps) => {
  switch (code) {
    case ErrorResponseCode.InvalidRequestParams:
      return TXT_ERROR_INVALID_REQUEST_PARAMS;
    case ErrorResponseCode.NotFound:
      return TXT_ERROR_NOT_FOUND;
    case ErrorResponseCode.NameNotFound:
      return TXT_ERROR_NAME_NOT_FOUND;
    case ErrorResponseCode.Unauthorized:
      return TXT_ERROR_UNAUTHORIZED;
    case ErrorResponseCode.IntegrationError:
      return TXT_ERROR_INTEGRATION_ERROR;
    case ErrorResponseCode.ServerError:
      return TXT_ERROR_SERVER_ERROR;
    case ErrorResponseCode.Forbidden:
      return TXT_ERROR_FORBIDDEN;
    case ErrorResponseCode.AlreadyExists:
      return TXT_ERROR_ALREADY_EXISTS;
    case ErrorResponseCode.BadRequest:
      return TXT_ERROR_BAD_REQUEST;
    case ErrorResponseCode.ClosedForWrite:
      return TXT_ERROR_CLOSED_FOR_WRITE;
    case ErrorResponseCode.ImageNotFound:
      return TXT_ERROR_IMAGE_NOT_FOUND;
    case ErrorResponseCode.ReadImageBytesError:
      return TXT_ERROR_READ_IMAGE_BYTES_ERROR;
    case ErrorResponseCode.CompanyNotFound:
      return TXT_ERROR_COMPANY_NOT_FOUND;
    case ErrorResponseCode.MenuNotFound:
      return TXT_ERROR_MENU_NOT_FOUND;
    case ErrorResponseCode.MenuItemNotFound:
      return TXT_ERROR_MENU_ITEM_NOT_FOUND;
    case ErrorResponseCode.DebtorUser:
      return TXT_ERROR_DEBTOR_USER;
    case ErrorResponseCode.CategoryNotFound:
      return TXT_ERROR_CATEGORY_NOT_FOUND;
    case ErrorResponseCode.ProductNotFound:
      return TXT_ERROR_PRODUCT_NOT_FOUND;
    default:
      return TXT_ERROR;
  }
};

export const getDayMeals = (meals: Meals, dayDate: string | undefined) =>
  Object.values(meals).filter((meal) => meal.day === dayDate);

export const MAX_COMMENT_SIZE = 500;
